"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.installExtensionRequestSchema = exports.extensionInstallSchema = exports.EXTENSION_CATALOGUE = exports.EXTENSION_CATEGORIES = exports.EXTENSION_IDS = void 0;
exports.catalogueEntry = catalogueEntry;
exports.populatedCategories = populatedCategories;
const zod_1 = require("zod");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ C32 · The extension catalogue. `2fazis.main.jsx` 1668–1840.               │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **CODE, NOT ROWS — and `0059` argues why at the table.** The catalogue changes when we ship,
 * not when a tenant does something; a database copy would mean a migration to fix a tagline and
 * user-facing copy somewhere the i18n catalogue cannot reach.
 *
 * ⚠️⚠️ **NO PROSE HERE, EITHER.** This file carries the *facts* — id, vendor, icon, colour,
 * category, how many bullet points its pages have. Every sentence a reader sees lives in
 * `apps/web/src/i18n/catalogue.ts` under `ext.<id>.*`, because CLAUDE.md rule 7 admits no exceptions
 * and a marketplace that only speaks Hungarian is a marketplace half the product cannot read.
 * `canCount` and `howCount` exist so the screen can loop without a computed key — `i18n:check` reads
 * literal arguments only.
 *
 * ⚠️⚠️ **TWO ENTRIES, AND THE MOCKUP'S OTHER SIX ARE NOT HERE — AMENDED P2-5, 31 Aug 2026.** The
 * mockup lists eight and marks six *hamarosan*: Azure DevOps, Linear, GitHub, Slack, Aranyszámla,
 * Google Calendar. They shipped that way for one commit, behind a `ready` flag that made the server
 * refuse to install them — and **a catalogue page for something nobody can install is still a
 * promise nobody made**. The product owner's call is that the marketplace lists what works. When one
 * of the six becomes real it arrives here with its copy, which is the same work as flipping a flag
 * and considerably more honest in the meantime.
 *
 * The consequence worth knowing: there is no `ready` field and no *not ready* refusal any more. An
 * id this file does not carry is simply `not_found`.
 */
exports.EXTENSION_IDS = ['jira', 'youtrack'];
/**
 * The mockup's `MP_CATS`, minus its *Mind* — that is a filter state, not a category.
 *
 * ⚠️ **The taxonomy, not the populated set.** Both entries are `tasks` today; the other four stay
 * because they are where the next extensions land, and the screen renders a filter chip only for a
 * category something is actually in.
 */
exports.EXTENSION_CATEGORIES = [
    'tasks',
    'development',
    'communication',
    'finance',
    'calendar',
];
exports.EXTENSION_CATALOGUE = [
    {
        id: 'jira',
        vendor: 'Atlassian',
        icon: 'kanban',
        color: '#2F6FEB',
        category: 'tasks',
        canCount: 4,
        howCount: 4,
        adminCredentials: [
            { key: 'email', secret: false },
            { key: 'token', secret: true },
        ],
        memberConnects: true,
        containerNoun: 'space',
        /**
         * ⚠️ Webhooks, registered by us. Atlassian POSTs to
         * `${origin}/api/integrations/webhooks/jira/:token` — the `/api` prefix is `web`'s nginx,
         * which is the only ingress from the internet (R-22); the controller serves the rest at the
         * API's own root.
         */
        pushes: true,
    },
    {
        id: 'youtrack',
        vendor: 'JetBrains',
        icon: 'circle-dot',
        color: '#B541BF',
        category: 'tasks',
        canCount: 4,
        howCount: 3,
        adminCredentials: [{ key: 'token', secret: true }],
        memberConnects: false,
        containerNoun: 'project',
        /** ⚠️ **No webhook API exists** (§1.6). The `integration-poll` chore is how change arrives. */
        pushes: false,
    },
];
function catalogueEntry(id) {
    return exports.EXTENSION_CATALOGUE.find((entry) => entry.id === id) ?? null;
}
/** The categories something is actually in, in the taxonomy's order. The filter chips' source. */
function populatedCategories() {
    return exports.EXTENSION_CATEGORIES.filter((category) => exports.EXTENSION_CATALOGUE.some((entry) => entry.category === category));
}
/**
 * One install as the API returns it.
 *
 * ⚠️ **The facts travel; the copy does not.** The client already has the catalogue — it is in
 * `shared` — so the wire carries the id and the install state and nothing that would need
 * translating on the way.
 */
exports.extensionInstallSchema = zod_1.z.object({
    extensionId: zod_1.z.enum(exports.EXTENSION_IDS),
    installedAt: zod_1.z.string(),
    installedByName: zod_1.z.string().nullable(),
});
exports.installExtensionRequestSchema = zod_1.z.object({ extensionId: zod_1.z.enum(exports.EXTENSION_IDS) });
//# sourceMappingURL=catalogue.js.map